import Board from "./components/Board/Board";
import Board2 from "./components/Board2/Board";
// import BoardFC from './components/Board/BoardFC';
import "./App.scss";
import { Route, Router, Routes } from "react-router";

import { BrowserHistory } from "history";
import { PropsWithChildren, useLayoutEffect, useState } from "react";
import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

const HistoryRouter = ({
  basename,
  children,
  history,
}: PropsWithChildren<{
  basename?: string | undefined;
  history: BrowserHistory;
}>) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      basename={basename}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    >
      {children}
    </Router>
  );
};

function App() {
  return (
    <div>
      <HistoryRouter history={history}>
        <Routes>
          <Route path="size30" element={<Board />} />
          <Route path="size40" element={<Board2 />} />
          <Route path="" element={<Board2 />} />
        </Routes>
      </HistoryRouter>
    </div>
  );
}

export default App;
